import React from 'react';
import { Half } from './components/Half';
import FooterButtonContainer from './components/FooterButtonContainer';
import { FormButton } from '../../ui/buttons/FormButton';
import { CustomSticky } from '../../ui/sticky/CustomSticky';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import routes from 'utils/routes';
import { useTranslation } from 'react-i18next';

const NewTicketFormFooter = ({ ticketFormFooterData }) => {
  const {
    backendErrors,
    setShowErrors,
    isWaitingForResponse,
    submitFormikForm,
  } = ticketFormFooterData;

  const dispatch = useDispatch();
  const { t } = useTranslation('Emergencies');
  const onCancel = () => {
    dispatch(push(`${routes.emergencies}/`));
  };
  const hasBackendErrors = Object.keys(backendErrors).length > 0;

  return (
    <>
      <Half>
        <FormButton variant="GHOST" onClick={onCancel}>
          {t('cancel')}
        </FormButton>
      </Half>
      <Half>
        <FormButton
          isDisabled={isWaitingForResponse}
          onClick={() => {
            setShowErrors(true);
            submitFormikForm();
          }}
        >
          {t('request_budget')}
          {hasBackendErrors && <> ⚠️ </>}
        </FormButton>
      </Half>
    </>
  );
};

const TicketDetailEditFormFooter = ({ ticketFormFooterData }) => {
  const {
    backendErrors,
    setShowErrors,
    isWaitingForResponse,
    submitFormikForm,
    // onCancel,
    onCancelTicket,
    dirty,
  } = ticketFormFooterData;
  const hasBackendErrors = Object.keys(backendErrors).length > 0;
  const { t } = useTranslation('Emergencies');
  return (
    <>
      {/* <FormButton variant="GHOST" onClick={onCancel}>
        Back
      </FormButton> */}
      {!!onCancelTicket && (
        <FormButton variant="GHOST" onClick={onCancelTicket}>
          {t('cancel')}
        </FormButton>
      )}
      <FormButton
        isDisabled={isWaitingForResponse || !dirty}
        onClick={() => {
          setShowErrors(true);
          submitFormikForm();
        }}
      >
        {t('save')} {hasBackendErrors && <> ⚠️ </>}
      </FormButton>
    </>
  );
};

const AcceptedQuoteFormFooter = ({ ticketFormFooterData }) => {
  const { onMarkTicketAsDone } = ticketFormFooterData;
  const { t } = useTranslation('Emergencies');
  return (
    <>
      <Half> </Half>
      <Half>
        {!!onMarkTicketAsDone && (
          <FormButton onClick={onMarkTicketAsDone}>
            {t('move_ticket')}
          </FormButton>
        )}
      </Half>
    </>
  );
};

export const TicketFormFooter = ({ ticketFormFooterData }) => {
  const { isEdit, isReadOnly, isQuoteAccepted } = ticketFormFooterData;
  if (!isQuoteAccepted && isReadOnly) return <></>;
  return (
    <CustomSticky>
      <FooterButtonContainer>
        {isReadOnly ? (
          <AcceptedQuoteFormFooter
            ticketFormFooterData={ticketFormFooterData}
          />
        ) : isEdit ? (
          <TicketDetailEditFormFooter
            ticketFormFooterData={ticketFormFooterData}
          />
        ) : (
          <NewTicketFormFooter ticketFormFooterData={ticketFormFooterData} />
        )}
      </FooterButtonContainer>
    </CustomSticky>
  );
};
